// extracted by mini-css-extract-plugin
export var badge = "_gj-2";
export var detailsPanel = "_gj-0";
export var resultRow = "_gj-1";